import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  forwardRef,
  OnChanges,
  InjectionToken,
  Inject,
  ViewChild,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";
import { ObjectUtils } from "@bfx/primeng/utils";

// BFX
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ICNInputControlState } from "./models/bfx-interface-controls.enums";
import { ActiveUser, ActiveUserProfilePromiseService } from "shared/cubiq-services";

// models
import { ICTimeControlModel } from "./models/bfx-interface-controls.models";
import { ICAutocompleteGenericModel } from "./models/bfx-interface-controls.models";

import qcompare from "qcompare";

export const TIME_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BfxTimeInputComponent),
  multi: true,
};

export const INPUT_TIME_SHOWSECONDS = new InjectionToken<string>("INPUT_TIME_SHOWSECONDSS");

export const INPUT_TIME_PATTERN = new InjectionToken<string>("INPUT_TIME_PATTERN");
export const SECS_VALIDATE_TIME_PATTERN: RegExp = new RegExp(
  "^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$",
);
export const NOSECS_VALIDATE_TIME_PATTERN: RegExp = new RegExp("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$");

export const INPUT_TIME_MASK = new InjectionToken<string>("INPUT_TIME_MASK");
export const SECS_MASK: string = "99:99:99";
export const NOSECS_MASK: string = "99:99";

export const INPUT_TIME_DEFAULT = new InjectionToken<string>("INPUT_TIME_DEFAULT");
export const SECS_DEFAULT: string = "HH:MM:SS";
export const NOSECS_DEFAULT: string = "HH:MM";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { OETimeMachineService } from "../../services/basic/oe-time-machine.service";
import {
  BfxAutoCompleteComponent,
  BfxAutoCompleteComponentState,
} from "app/bfx-element-library/bfx-autocomplete.component";
import { BfxTimeEditComponent } from "app/bfx-element-library/bfx-time-edit.component";
import { SpinDirection } from "../../../../shared/base-components/spinner-buttons.component";

@Component({
  selector: "bfx-time-input",
  templateUrl: "./html/bfx-time-input.html",
  providers: [TIME_CONTROL_VALUE_ACCESSOR, ObjectUtils],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BfxTimeInputComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input("userZone") input_setTimezoneToUserZone: boolean = true;

  @Input("suspend") input_suspend: boolean = false;

  @Input("adjustDropdownDir") input_adjustDropdown: boolean = false;

  @Input("label") input_label: string;

  @Input()
  enableInputTimezone: boolean = false;

  @Input()
  private _disabled: boolean = false;

  public get disabled(): boolean {
    return this._disabled;
  }

  public set disabled(value: boolean) {
    this._disabled = value;
    this.cd.markForCheck();
  }

  @Output() blur: EventEmitter<any> = new EventEmitter<any>();

  @Output() focus: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild("inputTimezone", { static: false })
  inputTimezone: BfxAutoCompleteComponent;

  @ViewChild("inputTime", { static: false })
  inputTime: BfxTimeEditComponent;

  // From external change state
  _externalState: ICNInputControlState;

  get externalState() {
    return this._externalState;
  }

  @Input()
  set externalState(value: any) {
    this.cd.markForCheck();
    this._externalState = value;

    if (ICNInputControlState.INVALID == value) {
      this.state = ICNInputControlState.INVALID;
      this._externalState = null;
    } else if (value != null) {
      this.validate();
    }
  }

  public timeInputName: string = "timeInput" + Math.random() * 100000;

  public autoClear: boolean = false;
  /***************************************/
  /* DATA */
  public config: any = {
    suspend: false, //
  };

  private _state: ICNInputControlState = ICNInputControlState.INACTIVE;

  public get state(): ICNInputControlState {
    return this._state;
  }

  @Input()
  public set state(value: ICNInputControlState) {
    this.cd.markForCheck();
    this._state = value;
  }

  /**
   * this is frequently modified by external components directly.
   *
   * explicit setters to pick up changes
   */
  public data = new BfxTimeInputComponent.Data(this.cd);

  private static Data = class {
    constructor(private cd: ChangeDetectorRef) {}
    _value: ICTimeControlModel = null;
    get value() {
      return this._value;
    }
    set value(value) {
      if (!qcompare(value, this._value)) {
        this._value = value;
        console.log(`bfx-time-input.value = %O`, value);
        this.cd.markForCheck();
      }
    }
    _label: string = null;
    get label() {
      return this._label;
    }
    set label(value) {
      this._label = value;
      this.cd.markForCheck();
    }
    _timeValue: string = null;
    get timeValue() {
      return this._timeValue;
    }
    set timeValue(value) {
      this._timeValue = value;
      if (value == null) {
      }
      this.cd.markForCheck();
    }
    _timeInputModel = null;
    get timeInputModel() {
      return this._timeInputModel;
    }
    set timeInputModel(value) {
      this._timeInputModel = value;
      this.cd.markForCheck();
    }
    // fixme
    _timezoneValue: any = null;
    get timezoneValue() {
      return this._timezoneValue;
    }
    set timezoneValue(value) {
      this._timezoneValue = value;
      this.cd.markForCheck();
    }
    _timezoneDatasetFiltered: Array<ICAutocompleteGenericModel> = null;
    get timezoneDatasetFiltered() {
      return this._timezoneDatasetFiltered;
    }
    set timezoneDatasetFiltered(value) {
      this._timezoneDatasetFiltered = value;
      this.cd.markForCheck();
    }
    _timezoneDataset: Array<ICAutocompleteGenericModel> = null;
    get timezoneDataset() {
      return this._timezoneDataset;
    }
    set timezoneDataset(value) {
      this._timezoneDataset = value;
      this.cd.markForCheck();
    }
    _timezoneImplDataset: Array<CubiqTS.TimeZoneImpl> = null;
    get timezoneImplDataset() {
      return this._timezoneImplDataset;
    }
    set timezoneImplDataset(value) {
      this._timezoneImplDataset = value;
      this.cd.markForCheck();
    }
    _userTimezoneCode: string = null; //
    get userTimezoneCode() {
      return this._userTimezoneCode;
    }
    set userTimezoneCode(value) {
      this._userTimezoneCode = value;
      this.cd.markForCheck();
    }
    _userTimeZoneModel: CubiqTS.TimeZoneImpl = null;
    get userTimeZoneModel() {
      return this._userTimeZoneModel;
    }
    set userTimeZoneModel(value) {
      this._userTimeZoneModel = value;
      this.cd.markForCheck();
    }
    _locked: boolean = false;
    get locked() {
      return this._locked;
    }
    set locked(value) {
      this._locked = value;
      this.cd.markForCheck();
    }
    _placeholder: string = NOSECS_DEFAULT;
    get placeholder() {
      return this._placeholder;
    }
    set placeholder(value) {
      this._placeholder = value;
      this.cd.markForCheck();
    }

    _mask: string = NOSECS_MASK;
    get mask() {
      return this._mask;
    }
    set mask(value) {
      this._mask = value;
      this.cd.markForCheck();
    }
    _default: string = NOSECS_DEFAULT;
    get default() {
      return this._default;
    }
    set default(value) {
      this._default = value;
      this.cd.markForCheck();
    }
    _pattern: RegExp = NOSECS_VALIDATE_TIME_PATTERN;
    get pattern() {
      return this._pattern;
    }
    set pattern(value) {
      this._pattern = value;
      this.cd.markForCheck();
    }
  };

  private menuScrollHeight: number = 150;

  public inputModified: boolean = false;

  /**********************************************************************/
  /* CONSTRUCTOR  + LIFE CYCLE HOOKS */
  constructor(
    private activeUserService: ActiveUserProfilePromiseService,
    private _oeTimeMachine: OETimeMachineService,
    public objectUtils: ObjectUtils,
    @Inject(INPUT_TIME_MASK) public in_mask: string,
    @Inject(INPUT_TIME_PATTERN) public in_pattern: RegExp,
    @Inject(INPUT_TIME_DEFAULT) public in_default: string,
    public cd: ChangeDetectorRef,
  ) {
    this.data.mask = in_mask;
    this.data.default = in_default;
    this.data.pattern = in_pattern;
  }

  ngOnInit() {
    this.initializeOnInit();
  }

  ngOnChanges() {
    this.initializeOnChanges();
  }

  /**********************************************************************/
  /* INITIALIZATION */
  protected initializeOnInit(): void {
    this.loadActiveUserTimezone();
    this.loadTimezones();
    this.initializeOnChanges();
  }

  protected initializeOnChanges(): void {
    if (this._externalState != null) {
      this.state = this._externalState;
    }

    if (
      this.input_label != null &&
      typeof this.input_label === "string" &&
      this.input_label.length > 0
    ) {
      this.data.label = this.input_label;
    }

    if (this.input_suspend != null) {
      this.config.suspend = this.input_suspend;
      if (this.config.suspend) {
        this.fillInTheBlanks();
        // setTimeout(this.onBlur(null),250);
      }
    }
  }
  // User Timezone
  private loadActiveUserTimezone(): void {
    if (this.input_setTimezoneToUserZone) {
      this.activeUserService.getActiveUserData().then((user: ActiveUser) => {
        if (user != null && user instanceof ActiveUser) {
          this.data.userTimezoneCode = user.timeZoneCd;
          if (this.data.timezoneImplDataset && this.data.userTimezoneCode) {
            let theTz: CubiqTS.TimeZoneImpl = this.data.timezoneImplDataset.find(
              (tz) => tz.id === this.data.userTimezoneCode,
            );
            if (theTz) {
              this.data.timezoneValue = new ICAutocompleteGenericModel(
                theTz.id,
                this.getTimezoneLabel(theTz),
              );
              if (this.data.value == null) {
                this.data.value = new ICTimeControlModel();
              } else if (typeof this.data.value == "string") {
                this.data.value = new ICTimeControlModel(this.data.value);
              }
              this.data.value.timezoneValue = this.data.timezoneValue;
              this.data.value.timezoneModel = theTz;
              this.data.userTimeZoneModel = theTz;
            }
          }
        } else {
          logger.out.error("ERROR: TimeInput.initializeOnInit(): ActiveUser not found!");
        }
      });
    }
  }

  // Timezone lookup // Utility
  private loadTimezones(): void {
    this.data.timezoneDataset = new Array<ICAutocompleteGenericModel>();
    this.data.timezoneImplDataset = this._oeTimeMachine.getTimeZoneImpls();
    if (
      this.data.timezoneImplDataset != null &&
      Array.isArray(this.data.timezoneImplDataset) &&
      this.data.timezoneImplDataset.length > 0
    ) {
      this.data.timezoneImplDataset.forEach((tzItem: CubiqTS.TimeZoneImpl) => {
        if (this.input_setTimezoneToUserZone && tzItem.id === this.data.userTimezoneCode) {
          this.data.timezoneValue = new ICAutocompleteGenericModel(
            tzItem.id,
            this.getTimezoneLabel(tzItem),
          ); //{ label: item.id, value: item.id };
          if (this.data.value == null) {
            this.data.value = new ICTimeControlModel();
          }
          this.data.value.timezoneValue = this.data.timezoneValue;
          this.data.value.timezoneModel = tzItem; //this.data.timezoneImplDataset.find((item)=>{ return item.id === this.data.timezoneValue;});
          this.data.userTimeZoneModel = tzItem;
        }
        this.data.timezoneDataset.push(
          new ICAutocompleteGenericModel(tzItem.id, this.getTimezoneLabel(tzItem)),
        );
      });
      this.filterTimezones({ query: "" });
      if (this.config.suspend) {
        this.onChange(null);
      }
    } else {
      logger.out.error("ERROR: TimeInput.loadTimezones(): Timezones load failed or empty array!");
    }
  }

  public filterTimezones(event): void {
    let result: Array<ICAutocompleteGenericModel> = [];
    let searchToken: string = event.query.toLowerCase();

    if (this.data.timezoneDataset != null && this.data.timezoneDataset.length > 0) {
      // client is selected, local filtering
      for (let item of this.data.timezoneDataset) {
        if (item.label.toLowerCase().indexOf(searchToken) >= 0) {
          result.push(item);
        }
        if (this.config.resultsToShow > 0 && result.length >= this.config.resultsToShow) {
          this.data.timezoneDatasetFiltered = result;
          return;
        }
      }
    }

    this.data.timezoneDatasetFiltered = result;
  }

  /**********************************************************************/
  /* VALUE ACCESSOR */

  onModelChange: Function = () => {};

  onModelTouched: Function = () => {};

  writeValue(value: any): void {
    this.data.value = value;
  }

  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  onShowDropdown($event): void {
    logger.out.info("show dropdown", $event);
  }

  onHideDropdown($event): void {
    logger.out.info("hide dropdown", $event);
  }

  focusInput(): void {
    if (this.inputTime != null) {
      this.inputTime.focus();
    }
  }

  /**********************************************************************/
  /* LOAD */
  public loadInputControl(valueModel: ICTimeControlModel): void {
    if (valueModel != null) {
      this.data.value = valueModel;
      this.data.timeValue = valueModel.timeValue;
      this.data.timezoneValue = valueModel.timezoneValue;
    } else {
      this.data.value = null;
    }
    this.onValuesChange();
  }

  /**********************************************************************/
  /* RESET */

  public resetInputControl(): void {
    this.cd.markForCheck();
    this.data.timeValue = this.data.placeholder;
    if (this.data.userTimezoneCode != null && this.data.userTimezoneCode !== "") {
      let timezoneImplModel = this.data.timezoneImplDataset.find((item) => {
        return item.id === this.data.userTimezoneCode;
      });
      this.data.userTimeZoneModel = timezoneImplModel;
      this.data.timezoneValue = new ICAutocompleteGenericModel(
        timezoneImplModel.id,
        this.getTimezoneLabel(timezoneImplModel),
      );
    }

    this.onValuesChange();

    this.state = ICNInputControlState.INACTIVE;
    this.data.locked = false;
    this.externalState = null;
    //
    this.inputModified = false;
    //
    this.initializeOnChanges();
  }
  /**********************************************************************/
  /* LOCKING */
  public lockInputControl(): void {
    this.data.locked = true;
    this.cd.markForCheck();
  }

  public unlockInputControl(): void {
    this.data.locked = false;
    this.cd.markForCheck();
  }
  /**********************************************************************/
  /* HANDLERS */
  public onChange(event: any): void {
    this.assignValuesToModel();
    this.onModelChange(this.data.value);
  }

  public onFocus($event: any): void {
    if (!this.inputModified) {
      this.inputModified = true;
      $event.firstFocus = true;
    } else {
      $event.firstFocus = false;
    }
    if (this.state === ICNInputControlState.INACTIVE) {
      this.state = ICNInputControlState.ACTIVE;
      this.inputTimezone.state = BfxAutoCompleteComponentState.ACTIVE;
    }
    this.onModelTouched();
    this.focus.emit($event);
  }

  public onBlur($event: any): void {
    this.onValuesChange();
    $event.internalState = this.state;
    this.blur.emit($event);
    console.log(`${this.constructor.name} ${ICNInputControlState[this.state]}`);
  }

  /**********************************************************************/
  /* INTERFACE API */
  public setModified(): void {
    this.inputModified = true;
    this.fillInTheBlanks();
    this.onChange(null);
  }

  /**********************************************************************/
  /* INTERNAL */
  onValuesChange(): void {
    if (this.validate()) {
      this.assignValuesToModel();
    } else {
      this.data.value = null;
    }
    this.onChange(this.data.value);
  }

  protected assignValuesToModel(): void {
    if (this.data.value == null) this.data.value = new ICTimeControlModel();
    if (typeof this.data.value === "string")
      this.data.value = new ICTimeControlModel(this.data.value);

    if (
      this.data.value.timeValue !== this.data.timeValue ||
      (this.data.value.timezoneValue != null &&
        this.data.value.timezoneValue.value !== this.data.timezoneValue.value) ||
      this.data.value.timezoneModel == null ||
      this.data.value.timezoneModel.id !== this.data.timezoneValue.value
    ) {
      this.data.value.timeValue = this.data.timeValue;
      this.data.value.timezoneValue = this.data.timezoneValue;
      if (this.data.timezoneValue) {
        let timezoneImplModel = this.data.timezoneImplDataset.find((item) => {
          return item?.id === this.data?.timezoneValue?.value;
        });
        if (timezoneImplModel != null) {
          this.data.value.timezoneModel = timezoneImplModel;
        } else {
          this.data.value.timezoneModel = null;
        }
      }
    }
  }

  public validate(): boolean {
    this.cd.markForCheck();
    this.fillInTheBlanks();
    if (this.data.timeValue != null && this.data.timezoneValue != null) {
      // Time validation
      let timeValid: boolean = this.data.pattern.test(this.data.timeValue);
      // Timezone validation
      let timezoneValid: boolean = false;
      if (typeof this.data.timezoneValue === "string" && this.data.timeValue !== "") {
        this.data.timezoneValue = new ICAutocompleteGenericModel(
          this.data.timezoneValue.toUpperCase(),
          this.data.timezoneValue.toUpperCase(),
        );
      }

      if (this.data.timezoneValue instanceof ICAutocompleteGenericModel) {
        timezoneValid =
          this.data.timezoneImplDataset.filter((item) => {
            return item.id === this.data.timezoneValue.value;
          }).length > 0;
      }
      // resolution
      if (timeValid && timezoneValid) {
        this.state = ICNInputControlState.VALID;
        this.inputTimezone.state = BfxAutoCompleteComponentState.VALID;
        this._externalState = null;
        return true;
      } else {
        this.state = ICNInputControlState.INVALID;
        this.inputTimezone.state = BfxAutoCompleteComponentState.INVALID;
        this._externalState = null;
        return false;
      }
    } else {
      this.state = ICNInputControlState.INACTIVE;
      this.inputTimezone.state = BfxAutoCompleteComponentState.INACTIVE;
      this._externalState = null;
      return true;
    }
  }

  protected fillInTheBlanks() {
    if (this.data.timeValue == null || this.data.timeValue === "") {
      this.data.timeValue = this.data.placeholder;
    } else if (this.data.timeValue != null && this.data.timeValue.length > 0) {
      this.data.timeValue = this.data.timeValue.replace(/_/g, "0");
    }
  }
  /* ************************************************************************ */
  /* Dropdown direction fix  */
  private adjustDropDown(event: any, items: Array<any>): void {
    logger.out.info("adjusting dropdown");
    let element: any = event.originalEvent.target;

    let componentElement: any = this.getAutoSuggestComponentElement(element);
    let dropDownElement: any = this.getDropDownElement(componentElement);
    let scrollBodyElement: any = this.getScrollBodyElement(componentElement);

    let scrollOffset: number = scrollBodyElement.scrollTop;

    let height: number = Math.min(items.length * 22 + 15, this.menuScrollHeight);
    // dropDownElement.style.height = height + 'px';

    let panelHeight: number = scrollBodyElement.offsetHeight;

    if (componentElement.offsetTop - scrollOffset + height > panelHeight) {
      dropDownElement.style.top = null;
      dropDownElement.style.bottom = "20px";
    } else {
      dropDownElement.style.bottom = null;
      dropDownElement.style.top = "20px";
    }
  }

  protected getAutoSuggestComponentElement(eventSourceElement: any): any {
    if (eventSourceElement.nodeName.toLowerCase() !== "bfx-autocomplete") {
      return this.getAutoSuggestComponentElement(eventSourceElement.parentElement);
    }

    return eventSourceElement;
  }

  protected getScrollBodyElement(eventSourceElement: any): any {
    if (
      typeof eventSourceElement?.className === "string" &&
      eventSourceElement.className.toLowerCase() !==
        "order-entry__panel-financials__additional__pane"
    ) {
      return this.getScrollBodyElement(eventSourceElement.parentElement);
    }

    return eventSourceElement;
  }

  protected getDropDownElement(autoSuggestComponentElement: any): any {
    return autoSuggestComponentElement.children[0].children[0].children[2];
  }

  protected getTimezoneLabel(tzItem: CubiqTS.TimeZoneImpl): string {
    let tzLabel: string = tzItem.id;
    if (typeof tzLabel === "string" && tzLabel.length > 4) {
      tzLabel = tzLabel.substring(0, 4);
    }
    return tzLabel;
  }

  handleSpin(direction: SpinDirection) {
    this.inputTime.spinTo(direction);
  }
}
